const accordionBtns = document.querySelectorAll(".accordion");

accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {
    // Toggle the active class for the accordion button
    this.classList.toggle("is-open");

    // Find the corresponding accordion content
    let accordionId = this.getAttribute("data-accordion");
    let content = document.querySelector(`.accordion-content[data-accordion="${accordionId}"]`);

    if (content) {
      if (content.style.maxHeight) {
        // If the accordion is open, close it
        content.style.maxHeight = null;
        content.style.opacity = 0;
        content.classList.remove('open');

      } else {
        // Temporarily set maxHeight to auto to allow full height calculation
        content.style.maxHeight = 'none';

        // Trigger reflow to reset animation
        let fullHeight = content.scrollHeight + 'px'; // Calculate full height

        content.style.maxHeight = '0px'; // Reset max-height before opening
        content.offsetHeight; // Force reflow

        // Apply new max-height for smooth transition
        content.style.maxHeight = fullHeight;
        content.style.opacity = 1;
        content.classList.add('open');

        // After the transition ends, reset maxHeight to auto for dynamic content
        content.addEventListener('transitionend', function setAutoHeight() {
          if (content.style.maxHeight !== '0px') {
            content.style.maxHeight = 'auto';
          }
          content.removeEventListener('transitionend', setAutoHeight);
        });
      }
    }
  };
});
